import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export function ProtectedRoute({ roles, children }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-phoenix-bg">
                <Loader2 className="h-8 w-8 text-phoenix-navy animate-spin" />
            </div>
        );
    }

    if (!user) {
        const fallback = roles && roles.includes("inmate") ? "/claim-access" : "/login";
        return <Navigate to={fallback} state={{ from: location }} replace />;
    }

    if (roles && !roles.includes(user.role)) {
        // Redirect to default home for their role
        const home =
            user.role === "inmate" ? "/inmate" :
            user.role === "provider" ? "/provider" :
            user.role === "admin" ? "/admin" :
            ["institution", "institution_admin"].includes(user.role) ? "/institution" :
            "/";
        return <Navigate to={home} replace />;
    }

    return children;
}
